<template>
  <div 
    class="sm-billing-info__content-item-block"
    :class="{
      'hidden': !allowOldPMB && !allowNewPMB
    }"
  >
    <h4>Mailbox number (Unit)</h4>
    <p class="disabled">
      <template v-if="oldPMB">Сustomize mailbox or retrieve your old mailbox</template>
      <template v-else>Сustomize your mailbox</template>
    </p>
    <ul class="sm-billing-info__content-item-block-mailbox">
      <li
        v-if="allowOldPMB"
        :class="{
          'active': mailboxOption == 'old'
        }"
        @click="mailboxOption = 'old'"
      >
        <div class="sm-billing-info__content-item-block-mailbox-flex">
          <radiobutton-block
            :name="'mailboxOption'"
            :checked="mailboxOption == 'old'"
            @click.prevent
          />
          <h6>Retrieve my old mailbox (Unit)</h6>
          <span class="sm-txt-nowrap">for {{formatPrice(oldPMBPrice)}}</span>
        </div>
        <p class="disabled">Your old mailbox number is #{{oldPMB.id}}</p>
      </li>
      <li
        v-if="allowNewPMB"
        :class="{
          'active': mailboxOption == 'new'
        }"
        @click="mailboxOption = 'new'"
      >
        <div class="sm-billing-info__content-item-block-mailbox-flex">
          <radiobutton-block
            :name="'mailboxOption'"
            :checked="mailboxOption == 'new'"
            @click.prevent
          />
          <h6>Customize my mailbox (Unit)</h6>
          <span class="sm-txt-nowrap">for {{formatPrice(newPMBPrice)}}</span>
        </div>
        <dropdown-block
          v-model="newPMB"
          class="sm-dropdown scroll-y"
          :options="PMBList"
          :searchable="false"
        >
          <template slot="placeholder">
            <span>Select one of the available mailbox numbers...</span>
            <include-svg :name="'icon-arrow-b'" />
          </template>
          <template slot="singleLabel" slot-scope="props">
            <span>Unit #{{props.option.id}}</span>
            <include-svg :name="'icon-arrow-b'" />
          </template>
          <template slot="option" slot-scope="props" :value="props.option.id">
            <span>Unit #{{props.option.id}}</span>
          </template>
        </dropdown-block>
      </li>
      <li
        :class="{
          'active': mailboxOption == 'default'
        }"
        @click="mailboxOption = 'default'"
      >
        <div class="sm-billing-info__content-item-block-mailbox-flex">
          <radiobutton-block
            :name="'mailboxOption'"
            :checked="mailboxOption == 'default'"
            @click.prevent
          />
          <h6>Get a free mailbox number (Unit)</h6>
          <span class="sm-txt-nowrap">free</span>
        </div>
        <p class="disabled">Mailbox number is automatically generated</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import Bus from '@/utils/bus';
import Radiobutton from '@/components/Radiobutton';
import Multiselect from 'vue-multiselect';

export default {
  name: 'select-mailbox',
  components: {
    'radiobutton-block': Radiobutton,
    'dropdown-block': Multiselect,
  },
  data() {
    return {
      oldPMB: null,
      oldPMBPrice: null,
      PMBList: [],
      newPMB: null,
      newPMBPrice: 0,
      mailboxOption: 'default'
    }
  },
  computed: {
    ...mapGetters({
      userPlan: 'account/userPlan',
      provider: 'provider'
    }),
    allowNewPMB() {
      if (
        !this.provider.allow_user_select_mailbox_number ||
        !this.userPlan.has_private_mailbox ||
        !this.PMBList.length
      )
        return false;
        
      return true;
    },
    allowOldPMB() {
      if (
        //!this.provider.allow_user_select_mailbox_number || // Disabled by Hassan's request #4896
        //!this.userPlan.has_private_mailbox || // Disabled by Hassan's request #4896
        !this.oldPMB
        // || !this.oldPMB.was_pmb_used // Disabled by Hassan's request #4918
      )
        return false;
        
      return true;
    },
    selectedPMB() {
      if (this.mailboxOption == 'new')
        return {
          type: 'new',
          item: this.newPMB,
          price: this.newPMBPrice
        }

      if (this.mailboxOption == 'old')
        return {
          type: 'old',
          item: this.oldPMB,
          price: this.oldPMBPrice
        }

      return {
        type: 'default',
        item: null,
        price: 0
      }
    }
  },
  created() {
    Promise.all([
      this.getCustomerPMB(),
      this.getPMBList()
    ])
      .then(([old_pmb, pmb_list]) => {
        if (old_pmb && old_pmb.id) {
          this.oldPMB = old_pmb;
          this.oldPMBPrice = this.userPlan.re_use_pmb_fee;
        }

        if (pmb_list.length) {
          this.PMBList = pmb_list;
          this.newPMBPrice = this.provider.price_for_custom_mailbox;

          if (this.$route.query.pmb_id) {
            let item = this.PMBList.find(pmb => pmb.id == this.$route.query.pmb_id);

            if (item) {
              this.mailboxOption = 'new';
              this.newPMB = item;
            }
          }
        }
      });

    Bus.$on('process-pmb', (resolve) => {
      if (this.oldPMB) { // Have old pmb
        if (this.mailboxOption != 'old') { // Not selected old pmb -> remove it
          this.removePMB()
            .then(() => {
              if (this.mailboxOption == 'new' && this.newPMB) { // Selected new pmb
                this.addPMB(this.newPMB)
                  .then(() => {
                    resolve();
                  })
                  .catch(e => {
                    console.log('err add new pmb', e, e.response);
                    resolve();
                  });
              } else { // Not selected pmb
                resolve();
              }
            })
            .catch(e => {
              console.log('err remove old pmb', e, e.response);
              resolve();
            });
        } else { // Selected old pmb -> don't touch
          resolve();
        }
      } else { // Don't have old pmb
        if (this.mailboxOption == 'new' && this.newPMB) { // Selected new pmb
          this.addPMB(this.newPMB)
            .then(() => {
              resolve();
            })
            .catch(e => {
              console.log('err add new pmb', e, e.response);
              resolve();
            });
        } else { // Not selected pmb
          resolve();
        }
      }
    })
  },
  methods: {
    ...mapActions({
      getCustomerPMB: 'billing/getCustomerPMB',
      getPMBList: 'billing/getPMBList',
      addPMB: 'billing/addPMB',
      removePMB: 'billing/removePMB',
    }),
    formatPrice: FormatPrice
  },
  watch: {
    selectedPMB: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>